import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: 350px;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const Title = styled.div`
  color: #333333;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 8px;
  text-align: center;
`;

export const Description = styled.div`
  color: #4f4f4f;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
`;

export const Amount = styled.div`
  background-color: #f0f3f6;
  border-radius: 2.5px;
  color: #4f4f4f;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  padding: 8px 12px;
  width: 100%;
`;

export const StyledButton = styled(Button)`
  font-size: 14px;
  font-weight: 400;
  width: 100%;
`;
